var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"non-member-rewards"},[_c('cmg-member-loyalty-rewards'),_c('cmg-recaptcha')],1)}
var staticRenderFns = []

export { render, staticRenderFns }